/**
 * @author: howarchou@sina.com
 * @date: 2018/11/4
 */
import Toast from "./Toast";

var vueToast = {}, VToast, _toast;

vueToast.install = function (Vue, options) { // vue的install方法，用于定义vue插件
    // 如果toast还在，则不再执行
    if (_toast || document.getElementsByClassName('toast-box').length) {
        return
    }
    create();

    function create() {
        VToast = Vue.extend(Toast);
        _toast = new VToast();
        // 手动创建一个未挂载的实例
        _toast.$mount();
        // 挂载
        document.querySelector('body').appendChild(_toast.$el)
        return _toast;
    }

    Vue.prototype.$toast = { // 在Vue的原型上添加实例方法，以全局调用
        show(...args) { // 控制toast显示的方法
            _toast.show(...args)
        },
        hide() { // 控制toast隐藏的方法
            _toast.hide();
        }
    }
}
export default vueToast



// WEBPACK FOOTER //
// ./src/components/toast/index.js